import fetchApi from 'hooks/fetchApi';
import { useCallback, useRef, useState } from 'react';
import API_NAME from 'services/api';
import { AttenderStatus } from 'types';

export type SyncAttendingStatusCallback = (
  callback?: (status: AttenderStatus) => any
) => any;

interface AttendingStatusModalState {
  isVisible: boolean;
  status: AttenderStatus | null;
}

const useSyncAttendingStatus = (
  eventId: string,
  setData: (data: any) => void
) => {
  const [loading, setLoading] = useState(false);
  const [modalState, setModalState] = useState<AttendingStatusModalState>({
    isVisible: false,
    status: null,
  });
  const { action } = fetchApi();
  const previousStatusRef = useRef<AttenderStatus | null>(null);

  const syncAttendingStatus = useCallback(
    async (callback?: (status: AttenderStatus) => any) => {
      try {
        setLoading(true);
        const res = await action(API_NAME.GET_EVENT_ATTENDING_STATUS, {
          params: { eventId },
        });

        if (res?.data?.attendingStatus) {
          const newStatus = res.data.attendingStatus.status;

          setData((data: any) => ({
            ...data,
            attendingStatus: res?.data?.attendingStatus,
          }));

          if (previousStatusRef.current !== newStatus) {
            setModalState({
              isVisible: true,
              status: newStatus,
            });

            previousStatusRef.current = newStatus;
          }

          callback && callback(newStatus);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    [eventId, action, setData]
  );

 const closeModal = useCallback(() => {
     setModalState((prev) => ({
       ...prev,
       isVisible: false,
     }));
 }, []);

  return {
    syncAttendingStatus,
    syncing: loading,
    modalState,
    closeModal,
  };
};

export default useSyncAttendingStatus;
